module.exports = __webpack_public_path__ + "img/partners.8ee43dad.svg";